<template>
  <div v-if="visible && item" class="gx-ann-popup" @click.self="onClose">
    <div class="gx-ann-popup__panel">
      <div class="gx-ann-popup__head">
        <div class="gx-ann-popup__tags">
          <span class="gx-ann-popup__tag" :class="'gx-ann-popup__tag--' + (item.type || 'update')">
            {{ typeLabel(item.type) }}
          </span>
          <span v-if="item.important" class="gx-ann-popup__tag gx-ann-popup__tag--important">重要</span>
        </div>
        <button type="button" class="gx-ann-popup__close" aria-label="关闭" @click="onClose">×</button>
      </div>
      <h3 class="gx-ann-popup__title">{{ item.title }}</h3>
      <div v-if="item.cover_url" class="gx-ann-popup__cover">
        <img :src="item.cover_url" alt="" />
      </div>
      <p class="gx-ann-popup__summary">{{ summary }}</p>
      <div class="gx-ann-popup__actions">
        <button type="button" class="gx-ann-popup__btn gx-ann-popup__btn--ghost" @click="onClose">关闭</button>
        <button type="button" class="gx-ann-popup__btn gx-ann-popup__btn--primary" @click="onView">查看</button>
      </div>
    </div>
  </div>
</template>

<script>
import { announcementPopup, announcementRead } from '../../api/main/announcement'

export default {
  name: 'AnnouncementPopup',
  data() {
    return {
      visible: false,
      item: null,
      loading: false
    }
  },
  computed: {
    summary() {
      if (!this.item) return ''
      const raw = this.item.summary || this.item.content_text || this.stripHtml(this.item.content || '')
      return raw.length > 120 ? raw.slice(0, 120) + '…' : raw
    }
  },
  mounted() {
    this.fetchPopup()
  },
  methods: {
    stripHtml(html) {
      return String(html || '').replace(/<[^>]+>/g, '').replace(/\s+/g, ' ').trim()
    },
    typeLabel(type) {
      return type === 'activity' ? '活动' : '系统更新'
    },
    async fetchPopup() {
      if (this.loading) return
      this.loading = true
      try {
        const res = await announcementPopup()
        if (res && res.code === 200) {
          const data = res.data
          this.item = data && data.id ? data : null
          this.visible = !!this.item
        }
      } catch (e) {
        // 静默失败
      } finally {
        this.loading = false
      }
    },
    async markPopupShown() {
      if (!this.item || !this.item.id) return
      try {
        await announcementRead({ id: this.item.id, only_popup: true })
      } catch (e) { /* ignore */ }
    },
    async onClose() {
      await this.markPopupShown()
      this.visible = false
      this.$emit('closed', this.item)
    },
    async onView() {
      const id = this.item && this.item.id
      await this.markPopupShown()
      this.visible = false
      this.$emit('closed', this.item)
      if (id) this.$router.push('/new_announcement/' + id)
    }
  }
}
</script>

<style scoped>
.gx-ann-popup {
  position: fixed;
  inset: 0;
  z-index: 4000;
  background: rgba(10, 12, 24, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.gx-ann-popup__panel {
  width: 440px;
  max-width: 100%;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 18px 48px rgba(0, 0, 0, 0.28);
  padding: 20px 22px 18px;
}
.gx-ann-popup__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}
.gx-ann-popup__tags { display: flex; gap: 6px; flex-wrap: wrap; }
.gx-ann-popup__tag {
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 4px;
  background: #EEF1F7;
  color: #5A6478;
}
.gx-ann-popup__tag--update { background: rgba(64, 128, 255, 0.12); color: #3A6FE0; }
.gx-ann-popup__tag--activity { background: rgba(255, 122, 40, 0.12); color: #E06A1A; }
.gx-ann-popup__tag--important { background: rgba(220, 60, 60, 0.12); color: #C8443C; }
.gx-ann-popup__close {
  border: none;
  background: transparent;
  font-size: 22px;
  line-height: 1;
  color: #8A95B0;
  cursor: pointer;
}
.gx-ann-popup__title {
  margin: 0 0 12px;
  font-size: 18px;
  font-weight: 700;
  color: #1A1A2E;
  line-height: 1.4;
}
.gx-ann-popup__cover {
  width: 100%;
  aspect-ratio: 16 / 9;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 12px;
  background: #F3F5FA;
}
.gx-ann-popup__cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.gx-ann-popup__summary {
  margin: 0 0 18px;
  font-size: 13px;
  line-height: 1.7;
  color: #4A4A6A;
}
.gx-ann-popup__actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
.gx-ann-popup__btn {
  min-width: 88px;
  height: 36px;
  border-radius: 8px;
  border: 1px solid transparent;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
}
.gx-ann-popup__btn--ghost {
  background: #fff;
  border-color: #D8DEEA;
  color: #5A6478;
}
.gx-ann-popup__btn--primary {
  background: linear-gradient(135deg, #C8443C, #E05858);
  color: #fff;
}
</style>
